// Gate for the 99 Percentile Challenge: only students with an active (non-expired - the
// purchasedPacks the backend returns are already filtered to endDate >= now) JEE Main test
// series purchase can proceed. purchasedPacks come from usePackStorage, each with a populated
// `exam` (packController.js's `.populate({ path: 'exam', select: 'title' })` keeps `_id` too,
// since populate's `select` only drops `_id` when explicitly excluded with `-_id`).
// Matched by exam _id, not title - the same stable id backend-migration's own
// scripts/seedChallengeData.js already hardcodes as JEE_MAIN_EXAM_ID for the challenge's
// exam-scoped pool matching, so this isn't a new cross-environment assumption, just reusing the
// one the challenge feature already depends on. A title substring match would silently
// break/over-match on a rename or a second exam whose title happens to contain "jee main".
export const JEE_MAIN_EXAM_ID = '605dfcb2f226ac25a8bd5fef';
export const hasActiveJeeMainPack = (purchasedPacks) =>
  (purchasedPacks || []).some((pack) => pack.exam?._id === JEE_MAIN_EXAM_ID);

export const JEE_MAIN_BUY_URL =
  'https://quizrr.in/jee-main-test-series?utm_source=quizrr_app&utm_medium=challenge&utm_campaign=99days99percentile';

const MATHONGO_EMAIL_SUFFIX = '@mathongo.com';

// Soft-launch gate: when platformSettings.challengeInternalOnly is on, only @mathongo.com accounts
// can access the challenge at all - mirrors the same check the backend enforces
// (backend-migration's middlewares/challengeInternalAccess.js), so the client never shows/links to
// something the server would 403 anyway.
export const canAccessChallenge = (platformSettings, userEmail) =>
  !platformSettings?.challengeInternalOnly || Boolean(userEmail?.toLowerCase().endsWith(MATHONGO_EMAIL_SUFFIX));
